import { render } from "./SavedTablesContainer.vue?vue&type=template&id=33d3100e&scoped=true"
import script from "./SavedTablesContainer.vue?vue&type=script&lang=js"
export * from "./SavedTablesContainer.vue?vue&type=script&lang=js"

import "./SavedTablesContainer.vue?vue&type=style&index=0&id=33d3100e&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d3100e"]])

export default __exports__
import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'directives', {ClosePopup});
